import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { useAuthStore } from '@/stores/authStore'
import type { StudentContractLastSigned } from '@/types/api'
import { SIGNED_CONTRACT_KEY, signedContract } from './signedContract'

/**
 * Ultimo contrato assinado do aluno, com o mesmo cache para o menu e para Contrato e
 * privacidade. Usa `last_signed` do GET /contract: vale mesmo com outra compra pedindo
 * assinatura, com full_access ou so com plano gratuito.
 */
export function useSignedContract(): StudentContractLastSigned | null {
  const role = useAuthStore((state) => state.user?.role)
  const query = useQuery({
    queryKey: SIGNED_CONTRACT_KEY,
    queryFn: () => api.contract.get(),
    enabled: role === 'student',
    staleTime: 5 * 60 * 1000,
    retry: false,
  })
  return signedContract(query.data?.contract)
}
